module.exports = __webpack_public_path__ + "static/media/en.47934004.mp4";